(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    var popup = document.getElementById('bb-newsletter-popup');
    if (!popup) return;

    var storageKey = 'bb-popup-dismissed';
    var alreadyDismissed = false;
    try {
      alreadyDismissed = window.localStorage.getItem(storageKey) === '1';
    } catch (e) {
      alreadyDismissed = false;
    }

    var justSubscribed = popup.querySelector('.bb-popup__success');
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 5000;

    function closePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (e) {}
    }

    function openPopup() {
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
    }

    popup.querySelectorAll('[data-bb-popup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    if (justSubscribed) {
      openPopup();
    } else if (!alreadyDismissed) {
      setTimeout(openPopup, delay);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
